/* @flow strict */

import * as React from 'react';
import Dropzone from 'react-dropzone';

import './styles.scss';

type PropsType = {
  imageSource?: null | string | ArrayBuffer,
  onDrop: (acceptedFiles: Array<File>) => any,
  onlyImages?: boolean,
  image_crop_info?: any,
  noImgParams?: boolean,
  imageSizeLimit?: number
};

const DropZone = ({ imageSource, onDrop: handleDrop, onlyImages, allowMultiple, image_crop_info, noImgParams, imageSizeLimit }: PropsType): React.Element<typeof React.Fragment> => {
  const { x1, x2, y1, y2 } = image_crop_info || {};
  const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})&width=640;`;
  const maxSize = imageSizeLimit || 2;

  return (
    <>
      <Dropzone
        onDrop={handleDrop}
        accept={onlyImages && 'image/jpeg, image/png, image/gif'}
        maxSize={(maxSize * 1024) * 1024}
      >
        {({ getRootProps, getInputProps }): React.Element<'section'> => (
          <section>
            <div {...getRootProps()} className="dropZone" >
              <div style={{ marginBottom: '37.62755102%' }} />
              {imageSource &&
                <img
                  style={{ width: '100%' }}
                  src={`${imageSource}${!noImgParams ? `?${imageUrlParams}` : ''}`}
                />
              }
              <input {...getInputProps({ multiple: allowMultiple })} />
              <div className="dz-message">
                <div className="dz-image" />
                <div className="dz-button">
                  <i className="icon icon-image" />
                  <span>drop picture here to upload</span>
                  <div style={{ fontSize: '0.8em', opacity: '0.7', textAlign: 'center' }}>
                    Maximum upload file size: {maxSize}MB
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </Dropzone>
    </>);
};

export default DropZone;
